import React, { useState, useEffect } from 'react'
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { notification } from 'antd'

import { fetchProductTypes } from 'pages/settings/settingApis'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/404'
import { getMe } from 'services/authApis'
import { isUserAuthenticated } from 'utils'
import { getLeftMenuData, getSettingsMenuData } from 'services/menu'
import routes from './routes'
import { AppProvider } from './useApp'
import { fetchCountries, fetchAdmins } from './services/appApis'

const retrievedMe = localStorage.getItem('me')

// TODO: remove this temporary solution
export const allowedMenuForAdmin = ['orders', 'members', 'member', 'packages']
const menuLeftData = getLeftMenuData()

const settingsMenuData = getSettingsMenuData()

notification.config({
  placement: 'topRight',
  duration: 8,
})

const App = () => {
  const isMobileView = useMediaQuery({ query: '(max-width: 768px)' })
  const [appLoading, setAppLoading] = useState(false)
  const [countries, setCountries] = useState([])
  const [admins, setAdmins] = useState([])
  const [productTypes, setProductTypes] = useState([])
  const [me, setMe] = useState({
    ...(retrievedMe && retrievedMe.length ? JSON.parse(retrievedMe) : {}),
  })
  const userAuthenticated = isUserAuthenticated()

  // TODO remove
  const filteredMenuLeft =
    me.email !== 'volkan@gekron.com'
      ? menuLeftData
      : menuLeftData.filter(item => allowedMenuForAdmin.includes(item.key))

  const [appSettings, setAppSettings] = useState({
    isMobileView,
    isMobileMenuOpen: false,
    isLightTheme: true,
    isSettingsOpen: false,
    isMenuTop: false,
    isMenuCollapsed: true,
    isBorderless: true,
    isSquaredBorders: false,
    isFixedWidth: false,
    isMenuShadow: false,
    locale: 'en-US',
    menuLeftData: filteredMenuLeft,
    settingsMenuData,
  })

  const getProductTypes = async () => {
    const res = await fetchProductTypes()
    setProductTypes(res.data.result.types)
  }

  const getCountries = async () => {
    const res = await fetchCountries()
    setCountries(res.data.result.countries)
  }

  const getAdmins = async () => {
    const res = await fetchAdmins()
    setAdmins(res.data.result.admins)
  }

  const initApp = async () => {
    if (userAuthenticated) {
      getCountries()
      getAdmins()
      getProductTypes()

      if (!me.id) {
        const res = await getMe()
        if (!res.errors) {
          localStorage.setItem('token', res.data.result.token.access_token)
          localStorage.setItem('expiresIn', res.data.result.token.expires_in)
          localStorage.setItem('me', JSON.stringify(res.data.result.user))
          setMe(res.data.result.user)
        } else {
          notification.error({
            message: 'Error',
            description: 'Something went wrong',
          })
        }
      }
    }
  }

  const updateLocalMe = newMe => {
    setMe(newMe)
    localStorage.setItem('me', JSON.stringify(newMe))
  }

  useEffect(() => {
    initApp()
  }, [userAuthenticated])

  useEffect(() => {
    setAppSettings({
      ...appSettings,
      isMobileView,
    })
  }, [isMobileView])

  const value = {
    me,
    admins,
    countries,
    setMe: updateLocalMe,
    appLoading,
    setAppLoading,
    appSettings,
    setAppSettings,
    productTypes,
    getProductTypes,
  }

  return (
    <AppProvider value={value}>
      <BrowserRouter>
        <IndexLayout>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
            {routes.map(route => (
              <Route
                path={route.path}
                component={route.component}
                key={route.path}
                exact={route.exact}
              />
            ))}
            <Route component={NotFoundPage} />
          </Switch>
        </IndexLayout>
      </BrowserRouter>
    </AppProvider>
  )
}

export default App
